export default {
	label: 'Reegel | Reeglid',
	addRule: 'Lisa reegel',
}
